import axios, { type AxiosInstance, type AxiosResponse } from 'axios'
import { BaseResponse } from '@/common/api/types/BaseResponse.ts'

const apiClient: AxiosInstance = axios.create({
  baseURL: `/api/v1/`,
  timeout: 360000,
  headers: {
    'Content-Type': 'application/json',
  },
})

const createPromise = <T>(axiosRequest: Promise<AxiosResponse<any, any>>): Promise<T> => {
  return new Promise((resolve, _reject) => {
    axiosRequest
      .then(response => {
        if (response.request.statusCode >= 400 && response.request.StatusCode < 600)
          _reject(
            new BaseResponse(null as T, response.request.statusCode, false).AddErrors(
              response.request.error,
            ),
          )
        else resolve(response.data)
      })
      .catch(error => {
        if (!error.response) {
          _reject(
            new BaseResponse(null as T, 500, false).AddErrors([
              'No response received from the server',
            ]),
          )

          return
        }

        if (Object.prototype.hasOwnProperty.call(error.response.data, 'summary')) {
          _reject(
            new BaseResponse(null as T, error.response.status, false).AddErrors(
              error.response.data.summary,
            ),
          )
        } else {
          _reject(
            new BaseResponse(null as T, error.response.status, false).AddErrors(
              error.response.data.errors,
            ),
          )
        }
      })
  })
}

export { apiClient as api, createPromise }
